import { render, staticRenderFns } from "./landAdd360.vue?vue&type=template&id=d28bdff2&scoped=true"
import script from "./landAdd360.vue?vue&type=script&lang=js"
export * from "./landAdd360.vue?vue&type=script&lang=js"
import style0 from "./landAdd360.vue?vue&type=style&index=0&id=d28bdff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28bdff2",
  null
  
)

export default component.exports